import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00175 = new TileLayer({
  title: 'Máscara 20100910',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20100910l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00175.setVisible(false);

const layer00174 = new TileLayer({
  title: 'Máscara 20101020',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20101020l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00174.setVisible(false);
  
const layer00173 = new TileLayer({
  title: 'Máscara 20101105',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20101105l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00173.setVisible(false);
  
const layer00172 = new TileLayer({
  title: 'Máscara 20110201',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110201l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00172.setVisible(false);
  
const layer00171 = new TileLayer({
  title: 'Máscara 20110209',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110209l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00171.setVisible(false);
  
const layer00170 = new TileLayer({
  title: 'Máscara 20110225',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110225l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00170.setVisible(false);
  
const layer00169 = new TileLayer({
  title: 'Máscara 20110321',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110321l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00169.setVisible(false);
  
const layer00168 = new TileLayer({
  title: 'Máscara 20110406',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110406l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00168.setVisible(false);
  
const layer00167 = new TileLayer({
  title: 'Máscara 20110508',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110508l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00167.setVisible(false);
  
const layer00166 = new TileLayer({
  title: 'Máscara 20110524',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110524l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00166.setVisible(false);
  
const layer00165 = new TileLayer({
  title: 'Máscara 20110601',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110601l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00165.setVisible(false);
  
const layer00164 = new TileLayer({
  title: 'Máscara 20110804',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110804l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00164.setVisible(false);
  
const layer00163 = new TileLayer({
  title: 'Máscara 20110828',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110828l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00163.setVisible(false);

export const grupoCapa01_11 = new LayerGroup({
  title: 'Ciclo Hidrológico 2010-2011',
  fold: 'close',
  layers: [layer00163, layer00164, layer00165, layer00166, layer00167, layer00168, layer00169, layer00170, layer00171, layer00172, layer00173, layer00174, layer00175]
});